import * as React from 'react';

import { cn } from '../lib/cn';

export type PillTone =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'neutral'
  | 'orange';

const toneClasses: Record<PillTone, string> = {
  success: 'bg-[var(--color-success-light)] text-[var(--color-success-dark)]',
  warning: 'bg-[var(--color-warning-light)] text-[var(--color-warning-dark)]',
  danger: 'bg-[var(--color-danger-light)] text-[var(--color-danger-dark)]',
  info: 'bg-[var(--color-info-light)] text-[var(--color-info-dark)]',
  neutral: 'bg-[var(--color-surface-2)] text-[var(--color-fg-secondary)]',
  orange: 'bg-[var(--color-accent-subtle)] text-[var(--color-accent)]',
};

const toneDot: Record<PillTone, string> = {
  success: 'bg-[var(--color-success)]',
  warning: 'bg-[var(--color-warning)]',
  danger: 'bg-[var(--color-danger)]',
  info: 'bg-[var(--color-info)]',
  neutral: 'bg-[var(--color-fg-muted)]',
  orange: 'bg-[var(--color-accent)]',
};

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: PillTone;
  size?: 'sm' | 'md';
  withDot?: boolean;
}

export const Pill = React.forwardRef<HTMLSpanElement, PillProps>(
  ({ className, tone = 'neutral', size = 'md', withDot, children, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-medium',
        size === 'sm' ? 'h-5 px-2 text-[10px]' : 'h-6 px-2.5 text-xs',
        toneClasses[tone],
        className,
      )}
      {...props}
    >
      {withDot ? <span className={cn('h-1.5 w-1.5 rounded-full', toneDot[tone])} /> : null}
      {children}
    </span>
  ),
);
Pill.displayName = 'Pill';
